/* eslint-disable import/no-cycle */
import { asyncComponent } from '@telus/isomorphic-core'

const PartnerPortalHome = process.env.BROWSER
  ? asyncComponent(/* istanbul ignore next */ () => import('./Container'))
  : require('./Container').default

export default PartnerPortalHome